var req = require("!!/opt/build/repo/node_modules/pug-loader/index.js!/opt/build/repo/src/app/ehs/views/accident/accident-step1/accident-step1.component.pug");
module.exports = (req['default'] || req).apply(req, [])